import * as R from 'ramda'

import { earnPointsFor } from '~/src/pos/retailOrder/earnPointsRule.js'

// Suggest the points this sale earns, unless the staff has said otherwise.
//
// A computer rather than a watcher because the figure depends on `amount`,
// which is itself computed — and coact fires watchers only for the path being
// edited and its ancestors, never for a sibling that a computer changed. A
// watcher on `amount` would simply never run.
//
// That leaves the computer having to tell its own writes apart from the
// staff's, since it runs on every change including the one where they typed
// into the field. It does that by comparing against the previous pass: if the
// value moved and we were not the ones who moved it, they were. Their number
// then stands until they clear the field, which hands it back to the rule.
//
// Runs after the computer that sets `amount`, so `amount` is current.
export default function computeEarnPoints(value, prevValue) {
  const current = R.path(['earnPoints', 'value'], value)
  const previous = R.path(['earnPoints', 'value'], prevValue)

  const cleared = R.isNil(current) || current === ''
  const touched = current !== previous

  const forced = touched ? !cleared : Boolean(value.earnPointsForce)

  if (forced) return { earnPointsForce: true }

  return {
    earnPointsForce: false,
    earnPoints: {
      // `amount` is already net of the discount and of anything redeemed, so
      // it is the whole input. Passing the redemptions here as well would
      // subtract them twice.
      value: earnPointsFor({ amount: R.propOr(0, 'amount', value) }),
    },
  }
}
